<template>
  <!-- 本组件为：符合element-ui风格的饼状图，如首页里的饼状图 -->
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from './resize'
import { thousandFn } from '@/utils/thousandFn.js'
import i18n from '@/i18n'
var colors = ['#a9d252', 'rgb(30,144,255)', '#a9d252', '#ed3e13', '#e46cbb']

var emphasisStyle = {
  itemStyle: {
    barBorderWidth: 1,
    shadowBlur: 10,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: 'rgba(0,0,0,0.5)'
  }
}
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    dataDetail: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null,
      legendData: []
    }
  },
  watch: {
    dataDetail: {
      handler(newValue, oldValue) {
        this.dataDetail = newValue // 把新值赋值给我们的属性数据
        this.initChart() // 刷新echarts图表
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
    })
    setTimeout(() => {
      this.initChart()
    }, 500)
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      var xAxisData = []
      var data1 = []
      var data2 = []

      for (var i = 1; i <= 24; i++) {
        if (i < 10) {
          xAxisData.push('0' + i + ':00')
        } else {
          xAxisData.push(i + ':00')
        }
      }
      for (var j = 0; j < this.dataDetail.length; j++) {
        var idx = this.dataDetail[j]
        if (idx.chargedAh) { data1.push(Math.round(idx.chargedAh / 100)) } else { data1.push(0) }
        if (idx.dischargedAh) { data2.push(-Math.round(idx.dischargedAh / 100)) } else { data2.push(0) }
      }
      var option = {
        color: colors,
        backgroundColor: '#fff',
        legend: {
          data: [i18n.t('basicinfo.Charged'), i18n.t('basicinfo.DisCharged')]
          // left: 10
        },
        tooltip: {
          formatter: (b) => {
            var htmlStr = ''
            htmlStr += b.name + '<br/>'// x轴的名称
            htmlStr += '<div>'
            // 圆点
            htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + b.color + ';"></span>'
            // 圆点后面显示的文本
            var m
            if (b.value < 0) { m = -b.value } else { m = b.value }
            htmlStr += b.seriesName + '：' + m + 'Ah'
            htmlStr += '</div>'
            return htmlStr
          }
        },
        xAxis: {
          data: xAxisData,
          // name: 'X Axis',
          axisLine: { onZero: true }
          // splitLine: { show: false },
          // splitArea: { show: false }
        },
        yAxis: {
          splitArea: { show: true },
          // max: max,
          // min: min
          type: 'value',
          splitLine: {
            show: true
          },
          axisLabel: {
            formatter: function(value) {
              if (value < 0) { var value1 = -value; return value1 + 'Ah' } else { return value + 'Ah' }
            }
          }
        },
        grid: {
          // left: 100,
          top: 40,
          bottom: 30
        },
        series: [
          {
            name: i18n.t('basicinfo.Charged'),
            type: 'bar',
            stack: 'one',
            emphasis: emphasisStyle,
            data: data1
          },
          {
            name: i18n.t('basicinfo.DisCharged'),
            type: 'bar',
            stack: 'one',
            emphasis: emphasisStyle,
            data: data2
          }
        ]
      }
      this.chart.setOption(option, true)
    }
  }
}
</script>
